var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { attrs: { cols: "12", lg: "12" } },
        [
          _vm.isRequired("renewables")
            ? _c(
                "CardSimple",
                { attrs: { title: "Renewables" } },
                [
                  _c("InputYearly", {
                    attrs: {
                      "error-messages": _vm.$utils.getIfExists(_vm.errors, [
                        "input",
                        "minimum_renewable",
                      ]),
                      label: _vm.schema.minimum_renewable.title,
                      hint: _vm.schema.minimum_renewable.tooltip,
                      suffix: "%",
                      type: "number",
                      num_years: _vm.num_years,
                      fill: "",
                      "fill-value": _vm.schema.minimum_renewable.items.default,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedInput.minimum_renewable,
                      callback: function ($$v) {
                        _vm.$set(_vm.computedInput, "minimum_renewable", $$v)
                      },
                      expression: "computedInput.minimum_renewable",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "v-col",
        { attrs: { cols: "12", lg: "12" } },
        [
          _vm.isRequired("emission-programs")
            ? _c(
                "CardSimple",
                { attrs: { title: "Emission Programs" } },
                [
                  _c("InputYearly", {
                    attrs: {
                      "error-messages": _vm.$utils.getIfExists(_vm.errors, [
                        "input",
                        "co2_price",
                      ]),
                      label: _vm.schema.co2_price.title,
                      hint: _vm.schema.co2_price.tooltip,
                      suffix: _vm.schema.co2_price.unit,
                      type: "number",
                      num_years: _vm.num_years,
                      fill: "",
                      "fill-value": _vm.schema.co2_price.items.default,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedInput.co2_price,
                      callback: function ($$v) {
                        _vm.$set(_vm.computedInput, "co2_price", $$v)
                      },
                      expression: "computedInput.co2_price",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "v-col",
        { attrs: { cols: "12", lg: "12" } },
        [
          _vm.isRequired("energy-efficiency")
            ? _c(
                "CardSimple",
                { attrs: { title: "Energy Efficiency" } },
                [
                  _c("InputYearly", {
                    attrs: {
                      "error-messages": _vm.$utils.getIfExists(_vm.errors, [
                        "input",
                        "efficient_power_capacity",
                      ]),
                      label: _vm.schema.efficient_power_capacity.title,
                      hint: _vm.schema.efficient_power_capacity.tooltip,
                      suffix: _vm.schema.efficient_power_capacity.unit,
                      type: "number",
                      num_years: _vm.num_years,
                      fill: "",
                      "fill-value":
                        _vm.schema.efficient_power_capacity.items.default,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedInput.efficient_power_capacity,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.computedInput,
                          "efficient_power_capacity",
                          $$v
                        )
                      },
                      expression: "computedInput.efficient_power_capacity",
                    },
                  }),
                  _c("InputYearly", {
                    attrs: {
                      "error-messages": _vm.$utils.getIfExists(_vm.errors, [
                        "input",
                        "efficient_investment_cost",
                      ]),
                      label: _vm.schema.efficient_investment_cost.title,
                      hint: _vm.schema.efficient_investment_cost.tooltip,
                      suffix: _vm.schema.efficient_investment_cost.unit,
                      type: "number",
                      num_years: _vm.num_years,
                      fill: "",
                      "fill-value":
                        _vm.schema.efficient_investment_cost.items.default,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedInput.efficient_investment_cost,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.computedInput,
                          "efficient_investment_cost",
                          $$v
                        )
                      },
                      expression: "computedInput.efficient_investment_cost",
                    },
                  }),
                  _c("InputYearly", {
                    attrs: {
                      "error-messages": _vm.$utils.getIfExists(_vm.errors, [
                        "input",
                        "efficient_maximum_capacity",
                      ]),
                      label: _vm.schema.efficient_maximum_capacity.title,
                      hint: _vm.schema.efficient_maximum_capacity.tooltip,
                      suffix: _vm.schema.efficient_maximum_capacity.unit,
                      type: "number",
                      num_years: _vm.num_years,
                      fill: "",
                      "fill-value":
                        _vm.schema.efficient_maximum_capacity.items.default,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedInput.efficient_maximum_capacity,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.computedInput,
                          "efficient_maximum_capacity",
                          $$v
                        )
                      },
                      expression: "computedInput.efficient_maximum_capacity",
                    },
                  }),
                  _c("InputYearly", {
                    attrs: {
                      "error-messages": _vm.$utils.getIfExists(_vm.errors, [
                        "input",
                        "efficient_maximum_build",
                      ]),
                      label: _vm.schema.efficient_maximum_build.title,
                      hint: _vm.schema.efficient_maximum_build.tooltip,
                      suffix: _vm.schema.efficient_maximum_build.unit,
                      type: "number",
                      num_years: _vm.num_years,
                      fill: "",
                      "fill-value":
                        _vm.schema.efficient_maximum_build.items.default,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedInput.efficient_maximum_build,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.computedInput,
                          "efficient_maximum_build",
                          $$v
                        )
                      },
                      expression: "computedInput.efficient_maximum_build",
                    },
                  }),
                  _c("v-text-field", {
                    attrs: {
                      "error-messages": _vm.$utils.getIfExists(_vm.errors, [
                        "input",
                        "energy_savings",
                        "messages",
                      ]),
                      label: _vm.schema.energy_savings.title,
                      hint: _vm.schema.energy_savings.tooltip,
                      suffix: _vm.schema.energy_savings.unit,
                      type: "number",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedInput.energy_savings,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.computedInput,
                          "energy_savings",
                          _vm._n($$v)
                        )
                      },
                      expression: "computedInput.energy_savings",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "v-col",
        { attrs: { cols: "12", lg: "12" } },
        [
          _vm.isRequired("financial-parameters")
            ? _c(
                "CardSimple",
                { attrs: { title: "Financial Parameters" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      "error-messages": _vm.$utils.getIfExists(_vm.errors, [
                        "input",
                        "discount",
                        "messages",
                      ]),
                      label: _vm.schema.discount.title,
                      hint: _vm.schema.discount.tooltip,
                      suffix: _vm.schema.discount.unit,
                      type: "number",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedInput.discount,
                      callback: function ($$v) {
                        _vm.$set(_vm.computedInput, "discount", _vm._n($$v))
                      },
                      expression: "computedInput.discount",
                    },
                  }),
                  _c("v-text-field", {
                    attrs: {
                      "error-messages": _vm.$utils.getIfExists(_vm.errors, [
                        "input",
                        "target_LCOE",
                        "messages",
                      ]),
                      label: "Target Joint Resource LCOE",
                      suffix: "$/kWh",
                      type: "number",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedInput.target_LCOE,
                      callback: function ($$v) {
                        _vm.$set(_vm.computedInput, "target_LCOE", _vm._n($$v))
                      },
                      expression: "computedInput.target_LCOE",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }